<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div
    class="listView flex-grow-0"
    role="group"
    :aria-label="$t('layoutSelector')"
  >
    <PrimeSelectButton
      v-model="layout"
      :options="options"
      :allow-empty="false"
      @change="onLayoutChange"
      :aria-label="$t('layoutSelector')"
    >
      <template #option="{ option }">
        <i
          :class="[
            option === 'list'
              ? 'ri-list-check'
              : option === 'grid'
                ? 'ri-grid-line'
                : 'ri-table-line',
          ]"
          aria-hidden="true"
        />
        <span class="sr-only">{{ getOptionLabel(option) }}</span>
      </template>
    </PrimeSelectButton>
  </div>
</template>

<script>
import SelectButton from "primevue/selectbutton";

export default {
  name: "LayoutSelector",
  components: {
    PrimeSelectButton: SelectButton,
  },
  emits: ["update-layout"],
  data() {
    return {
      layout: localStorage.getItem("contentViewLayout") || "datatable",
      options: ["list", "grid", "datatable"],
    };
  },
  methods: {
    onLayoutChange() {
      this.$emit("update-layout", this.layout);
    },
    getOptionLabel(option) {
      const labels = {
        list: this.$t("layoutList"),
        grid: this.$t("layoutGrid"),
        datatable: this.$t("layoutTable"),
      };
      return labels[option] || option;
    },
  },
};
</script>

<style scoped lang="css">
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
